import React from 'react'
import dayjs from 'dayjs'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Typography from '@mui/material/Typography'
import DateInput from '@/javascript/presentation/components/inputs/date-input'
import { useRoutingContext } from '../../hooks/use-routing-context'
import AccountMemberSelectionInput from '../selection/account-member-selection-input'
import WorkSelectionInput from '../selection/work-selection-input'
import WorkingHoursInput from '../selection/working-hours-input'
import RouteSuggestionButton from '../selection/route-suggestion-button'

export const StepSelection: React.FC = () => {
  const { date, setDate } = useRoutingContext()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <FormControl required>
          <FormLabel>Data</FormLabel>
          <DateInput
            disablePast 
            minDate={dayjs()} 
            value={date} 
            setValue={setDate} 
            label=""
          />
        </FormControl>
        <WorkingHoursInput />
      </Box>
      <WorkSelectionInput />
      <AccountMemberSelectionInput />
      <Typography variant='caption' color="error.main">
        * Indica um campo obrigatório
      </Typography>
      <RouteSuggestionButton />
    </Box>
  )
}
